<template>
  <carousel
    :per-page="1"
    pagination-color="#B3BCCB"
    pagination-active-color="#000000"
    class="info-carousel"
    :pagination-padding="7"
    :pagination-size="5"
    :navigation-enabled="false"
    :navigation-click-target-size="5"
  >
    <slide>
      <h3 class="heading -quaternary">You can make your routines flexible.</h3>
      <p>Set days to be required or optional.</p>
      <ul class="icon-key">
        <li>
          <i class="material-symbols-outlined btn-ico fill">radio_button_unchecked</i> Required
        </li>
        <li><i class="material-symbols-outlined btn-ico fill">trip_origin</i> Optional</li>
      </ul>
      <p>Set individual workouts to required, optional, or extra credit.</p>
      <ul class="icon-key">
        <li>
          <i class="material-symbols-outlined btn-ico fill">radio_button_unchecked</i> Required
        </li>
        <li><i class="material-symbols-outlined btn-ico fill">trip_origin</i> Optional</li>
        <li><i class="material-symbols-outlined btn-ico fill">stars</i> Extra Credit</li>
      </ul>
    </slide>

    <slide>
      <h3 class="heading -quaternary">
        You can edit the basics, but don't have to worry about the details.
      </h3>
      <p>
        Change basic Routine information like title, description, and length anytime you like. The
        rest of the details automatically update as you add workouts to your routine.
      </p>
    </slide>

    <slide>
      <h3 class="heading -quaternary">
        If you have multiple ideas for routines, you can create them all at once.
      </h3>
      <p>
        When you select a workout, you can choose between any of the routines you currently have in
        draft mode to update.
      </p>
    </slide>

    <slide>
      <h3 class="heading -quaternary">You don't have to add workouts one day at a time.</h3>
      <p>
        If you know you want to do a workout multiple times throughout your Routine, select all the
        days at once, then select Add.
      </p>
    </slide>

    <slide>
      <h3 class="heading -quaternary">Optional or extra credit workouts still count.</h3>
      <p>
        Optional and Extra Credit workouts don’t factor into your total routine details, but if you
        do them, they will still count toward your overall activity stats.
      </p>
    </slide>
  </carousel>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Carousel, Slide } from '@jambonn/vue-concise-carousel'

/**
 * Routine sidebar instructional on edit view
 */
export default defineComponent({
  name: 'RoutineInstructionsCarousel',
  components: {
    Carousel,
    Slide,
  },
  props: {},
})
</script>
